import Quadrant from './Quadrant';
import ParameterErrors from '../../../errors/ParameterErrors';
const { throwNotProvided } = ParameterErrors;
const QUADRANTS_FOR_YAW_PITCH_JSON_KEY='a';
const TWO_PI=Math.PI*2;
export default class QuadrantV3{
	constructor({quadrantsForYawPitch, pitchFromRestInSingleQuadrantRadians, pitchToRestInSingleQuadrantRadians }){
		this._quadrantsForYawPitch = quadrantsForYawPitch;
		this._pitchFromRestInSingleQuadrantRadians=pitchFromRestInSingleQuadrantRadians;
		this._pitchToRestInSingleQuadrantRadians=pitchToRestInSingleQuadrantRadians;
	}
	get quadrantLevels(){
		return this._quadrantLevels;
	}
	getObjectIds({yawRadians, pitchRadians, reasonsOut}){
		while(yawRadians<0)yawRadians+=TWO_PI;
		let allObjectIds = [];
		const yawIndex=Math.floor(yawRadians*this._quadrantsForYawPitch.length/TWO_PI);
		if(yawIndex<0)
			yawIndex=0;
		else{
			if(yawIndex>=this._quadrantsForYawPitch.length)
				yawIndex=this._quadrantsForYawPitch.length-1;
		}
		const quadrantsForPitch = this._quadrantsForYawPitch[yawIndex];
		let pitchIndex;
		if(pitchRadians<=this._pitchFromRestInSingleQuadrantRadians)
			pitchIndex=0;
		else{
			if(pitchRadians>=this._pitchToRestInSingleQuadrantRadians)
				pitchIndex=quadrantsForPitch.length-1;
			else{
				pitchIndex=Math.floor((pitchRadians-this._pitchFromRestInSingleQuadrantRadians)*quadrantsForPitch.length/(this._pitchToRestInSingleQuadrantRadians-this._pitchFromRestInSingleQuadrantRadians));
				if(pitchIndex>=quadrantsForPitch.length)
					pitchIndex=quadrantsForPitch.length-1;
			}
		}
		const quadrant = quadrantsForPitch[pitchIndex];
		if(reasonsOut)
			reasonsOut.reasons = quadrant.getReasons();
		return quadrant.getObjectIds();
	}
	static fromJSON(jObject, pitchFromRestInSingleQuadrantRadians, pitchToRestInSingleQuadrantRadians){
		const quadrantsForYawPitch = 
			jObject[QUADRANTS_FOR_YAW_PITCH_JSON_KEY]
			.map(quadrantsForPitchJArray=>
				quadrantsForPitchJArray.map(
					quadrantJObject=>Quadrant.fromJSON(quadrantJObject)
				)
			);
		return new QuadrantV3({quadrantsForYawPitch, pitchFromRestInSingleQuadrantRadians, pitchToRestInSingleQuadrantRadians});
	}
}